/** @format */

import {ChartTypeSettings} from 'components/charts/multiline-chart/model/common';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

const getChartTypeSettings = (space: Space): ChartTypeSettings<ChartIds> => {
  const settings: ChartTypeSettings<ChartIds> = {};
  const ids = Object.keys(space.widgetsSettings) as ChartIds[];

  ids.forEach(id => {
    const method = space.widgetsSettings[id]?.calcMethod;
    switch (method) {
      case 'sum': {
        settings[id] = 'secondary';
        break;
      }
      default: {
        settings[id] = 'primary';
      }
    }
  });

  return settings;
};

export default getChartTypeSettings;
